import { AxiosInstance } from 'axios';
import {
  CreateJounralEntryParams,
  DeleteJournalEntryParams,
  UpdateJournalEntryParams,
} from '@pages/JournalEntries/types';

export default class JournalEntriesAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getJournalEntries({
    tradeIds,
    compEntities,
  }: {
    tradeIds: number[];
    compEntities: string[];
  }) {
    return this.client.post('v2/hedging/journal-entries/manage/', {
      trade_ids: tradeIds,
      comp_entities: compEntities,
    });
  }

  async createJournalEntry(payload: CreateJounralEntryParams) {
    return this.client.post(
      'v2/hedging/journal-entries/create-update-delete/',
      payload,
    );
  }

  async updateJournalEntry(payload: UpdateJournalEntryParams) {
    return this.client.post(
      'v2/hedging/journal-entries/create-update-delete/',
      payload,
    );
  }

  async deleteJournalEntry(payload: DeleteJournalEntryParams) {
    return this.client.post(
      'v2/hedging/journal-entries/create-update-delete/',
      payload,
    );
  }

  async getJournalEntryTypes() {
    return this.client.get('v2/hedging/journal-entries/types/');
  }

  // Lightweight list of transaction IDs that have journal entries — feeds the JE trade selection dropdown.
  async getJETransactions() {
    return this.client.get('/v2/hedge-accounting/je-transactions/');
  }

  async deleteJournalEntriesByType(payload: {
    trade_id: number;
    je_type_codes: string[];
  }) {
    return this.client.delete('v2/hedge-accounting/delete-je-by-type/', {
      data: payload,
    });
  }
}
